import React, {Component} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {grid} from '../../utils/grid';
import {formatCount} from '../../utils/format';
import Text from '../typography/text';
import Fork from '../icons/fork.svg';
import Star from './star.svg';

const Container = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    marginRight: grid(0.5),
    marginLeft: grid(2)
  }
});

const StyledFork = glamorous(Fork)({
  width: 13.8,
  height: 20.4,
  marginTop: 4
});

export default class GithubStats extends Component {
  static propTypes = {
    forksCount: PropTypes.number.isRequired,
    stargazersCount: PropTypes.number.isRequired
  };
  render() {
    const {forksCount, stargazersCount} = this.props;
    return (
      <Container>
        <StyledFork /> <Text>{formatCount(forksCount)}</Text>
        <Star /> <Text>{formatCount(stargazersCount)}</Text>
      </Container>
    );
  }
}
